$(document).ready(function() {
    //ajax param
    let myajax = `//${window.location.host}/wp-admin/admin-ajax.php`,
        paramObj = {
            url: myajax,
            excludePost: null,
            action: 'filter',
            currentPage: 1,
        };

    function loadPost(paramObj) {
        $.ajax({
            url: paramObj.url,
            data: paramObj,
            type: 'post',
            beforeSend() {
                document.querySelectorAll('.ajax-container article').forEach(el => {
                    el.style.cssText = `
                        opacity: 0.5;
                        pointer-events: none;
                    `;
                });
            },
            complete() {
                $('html, body').animate({ scrollTop: $('.posts-wrapper').offset().top - 78 }, 500);
            },
            success(result) {
                document.querySelector('.ajax-container').innerHTML = result;
            },
            error(result) { dl.log(result); }
        });
    }

    //pagination numeric
    $(document).on('click', '.posts-wrapper .page-numbers', function H(e) {
        e.preventDefault();

        const __this = this;

        paramObj.excludePost = document.querySelector('.hero-post__text-box').dataset.id;

        if (__this.classList.contains('next')) {
            paramObj.currentPage = __this.querySelector('.pag-next').innerHTML;
        } else if (__this.classList.contains('prev')) {
            paramObj.currentPage = __this.querySelector('.pag-prev').innerHTML;
        } else {
            paramObj.currentPage = __this.innerHTML;
        }

        loadPost(paramObj);
    });
});
